import React from 'react';

const CandyMascot: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({ style, className }) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
  >
    <defs>
      <linearGradient id="candy-swirl" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#ec4899" />
        <stop offset="33%" stopColor="#a855f7" />
        <stop offset="66%" stopColor="#ec4899" />
        <stop offset="100%" stopColor="#a855f7" />
      </linearGradient>
    </defs>
    {/* Stick */}
    <rect x="14.5" y="21" width="3" height="10" rx="1.5" fill="#fbbf24" />
    {/* Lollipop circle */}
    <circle cx="16" cy="12" r="10" fill="url(#candy-swirl)" />
    {/* Swirl lines */}
    <path
      d="M16 2 A4 4 0 0 1 20 6"
      fill="none"
      stroke="white"
      strokeWidth="1.2"
      opacity="0.4"
    />
    <path
      d="M16 6 A6 6 0 0 1 22 12"
      fill="none"
      stroke="white"
      strokeWidth="1"
      opacity="0.3"
    />
    <path
      d="M16 10 A8 8 0 0 1 24 12"
      fill="none"
      stroke="#fef08a"
      strokeWidth="0.8"
      opacity="0.35"
    />
    {/* Glossy highlight */}
    <ellipse cx="12.5" cy="8.5" rx="3.5" ry="2.5" fill="white" opacity="0.22" />
    {/* Eyes */}
    <circle cx="13" cy="12" r="1.1" fill="white" />
    <circle cx="19" cy="12" r="1.1" fill="white" />
    <circle cx="13.2" cy="11.8" r="0.5" fill="#1a1a1a" />
    <circle cx="19.2" cy="11.8" r="0.5" fill="#1a1a1a" />
    {/* Smile */}
    <path
      d="M14 14.5 Q16 16.5 18 14.5"
      fill="none"
      stroke="white"
      strokeWidth="0.8"
      strokeLinecap="round"
    />
  </svg>
);

export default CandyMascot;
